module.exports = __webpack_public_path__ + "static/media/closeBtn.a17f5e2d.svg";